var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwTaiwan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H-7.5V45H60V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H26.25V22.5H60V0Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5625 11.8969L45.7969 12.7969L44.9156 13.0406L45.0844 12.375L45.5625 11.8969ZM41.1656 12.375L41.3344 13.0406L40.4531 12.7969L40.6875 11.8969L41.1656 12.375ZM45.0844 10.125L45.5625 10.6031L45.3844 11.25L45.0844 10.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3844 11.25L45.5625 11.8969L45.0844 12.375L45.3844 11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5621 10.6035L46.209 11.2504L45.5621 11.8973L45.384 11.2504L45.5621 10.6035ZM44.2496 13.2098L43.7715 13.6879L43.1246 13.5098L44.2496 13.2098ZM42.4777 13.6879L41.5777 13.9223L41.334 13.041L41.9996 13.2098L42.4777 13.6879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0004 13.2094L41.3348 13.0406L41.166 12.375L42.0004 13.2094ZM44.916 13.0406L44.6723 13.9219L43.7723 13.6875L44.2504 13.2094L44.916 13.0406ZM43.1254 13.5094L42.4785 13.6875L42.0004 13.2094L43.1254 13.5094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7719 13.6871L43.125 14.334L42.4781 13.6871L43.125 13.509L43.7719 13.6871ZM44.9156 9.45898L45.7969 9.70273L45.5625 10.6027L45.0844 10.1246L44.9156 9.45898ZM45.0844 12.3746L44.9156 13.0402L44.25 13.209L45.0844 12.3746ZM40.8656 11.2496L40.6875 10.6027L41.1656 10.1246L40.8656 11.2496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2496 9.29102L44.9152 9.45977L45.084 10.1254L44.2496 9.29102ZM41.1652 10.1254L41.334 9.45977L41.9996 9.29102L41.1652 10.1254ZM40.6871 11.8973L40.0402 11.2504L40.6871 10.6035L40.8652 11.2504L40.6871 11.8973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.166 10.1246L42.0004 9.29023L43.1254 8.99023L44.2504 9.29023L45.0848 10.1246L45.3848 11.2496L45.0848 12.3746L44.2504 13.209L43.1254 13.509L42.0004 13.209L41.166 12.3746L40.866 11.2496L41.166 10.1246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.166 12.375L40.6879 11.8969L40.866 11.25L41.166 12.375ZM40.6879 10.6031L40.4535 9.70312L41.3348 9.45938L41.166 10.125L40.6879 10.6031ZM41.3348 9.45938L41.5785 8.57812L42.4785 8.8125L42.0004 9.29062L41.3348 9.45938ZM43.7723 8.8125L44.6723 8.57812L44.916 9.45938L44.2504 9.29062L43.7723 8.8125ZM43.1254 8.99063L43.7723 8.8125L44.2504 9.29062L43.1254 8.99063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4777 8.81289L43.1246 8.16602L43.7715 8.81289L43.1246 8.99102L42.4777 8.81289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9996 9.29062L42.4777 8.8125L43.1246 8.99063L41.9996 9.29062ZM43.7715 13.6875L44.6715 13.9219L44.2496 15.4781L43.1246 14.3344L43.7715 13.6875ZM44.2496 15.4781L43.1246 19.6875L41.9996 15.4781L43.1246 14.3344L44.2496 15.4781ZM44.9152 13.0406L45.7965 12.7969L46.209 14.3344L44.6715 13.9219L44.9152 13.0406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2094 14.3344L47.3344 18.5625L44.25 15.4781L44.6719 13.9219L46.2094 14.3344ZM47.3344 12.375L50.4375 15.4781L46.2094 14.3344L45.7969 12.7969L47.3344 12.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5621 11.8969L46.209 11.25L47.334 12.375L45.7965 12.7969L45.5621 11.8969ZM45.5621 10.6031L45.7965 9.70312L47.334 10.125L46.209 11.25L45.5621 10.6031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3344 10.125L51.5625 11.25L47.3344 12.375L46.2094 11.25L47.3344 10.125ZM38.8969 12.375L40.4531 12.7969L40.0406 14.3344L35.8125 15.4781L38.8969 12.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3344 13.0406L41.5781 13.9219L40.0406 14.3344L40.4531 12.7969L41.3344 13.0406ZM42.4781 13.6875L43.125 14.3344L42 15.4781L41.5781 13.9219L42.4781 13.6875ZM40.6875 11.8969L40.4531 12.7969L38.8969 12.375L40.0406 11.25L40.6875 11.8969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 15.4785L38.8969 18.5629L40.0406 14.3348L41.5781 13.9223L42 15.4785ZM41.3344 9.45977L40.4531 9.70352L40.0406 8.16602L41.5781 8.57852L41.3344 9.45977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8969 10.125L35.8125 7.04062L40.0406 8.16562L40.4531 9.70312L38.8969 10.125ZM40.0406 8.16562L38.8969 3.9375L42 7.04062L41.5781 8.57812L40.0406 8.16562ZM38.8969 12.375L34.6875 11.25L38.8969 10.125L40.0406 11.25L38.8969 12.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6871 10.6031L40.0402 11.25L38.8965 10.125L40.4527 9.70312L40.6871 10.6031ZM44.2496 7.04062L47.334 3.9375L46.209 8.16562L44.6715 8.57812L44.2496 7.04062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9152 9.45977L44.6715 8.57852L46.209 8.16602L45.7965 9.70352L44.9152 9.45977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2094 8.16602L50.4375 7.04102L47.3344 10.1254L45.7969 9.70352L46.2094 8.16602ZM42.4781 8.81289L41.5781 8.57852L42 7.04102L43.125 8.16602L42.4781 8.81289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 7.04062L43.125 2.8125L44.25 7.04062L43.125 8.16562L42 7.04062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7719 8.81289L43.125 8.16602L44.25 7.04102L44.6719 8.57852L43.7719 8.81289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1254 16.0402C40.4796 16.0402 38.3348 13.8954 38.3348 11.2496C38.3348 8.60382 40.4796 6.45898 43.1254 6.45898C45.7712 6.45898 47.916 8.60382 47.916 11.2496C47.916 13.8954 45.7712 16.0402 43.1254 16.0402Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1254 15.4777C40.7903 15.4777 38.8973 13.5847 38.8973 11.2496C38.8973 8.91448 40.7903 7.02148 43.1254 7.02148C45.4605 7.02148 47.3535 8.91448 47.3535 11.2496C47.3535 13.5847 45.4605 15.4777 43.1254 15.4777Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwTaiwan);
export default __webpack_public_path__ + "static/media/tw Taiwan.9d80fe2b7a8efa07d9e0b459f11a0e39.svg";
export { ForwardRef as ReactComponent };